var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ad-cont"},[_c('div',{ref:"adcont",staticClass:"ad",attrs:{"id":"div-gpt-ad-1732099910544-0"}}),_c('van-icon',{staticClass:"close",style:({
        'top':_vm.top+'px',
        'right':_vm.right+'px'
    }),attrs:{"name":"cross","size":"20"},on:{"click":_vm.show}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }